import { render, staticRenderFns } from "./NewsletterModal.vue?vue&type=template&id=35468332&scoped=true"
import script from "./NewsletterModal.vue?vue&type=script&lang=js"
export * from "./NewsletterModal.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./NewsletterModal.vue?vue&type=style&index=0&id=35468332&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "35468332",
  "495096d3"
  
)

export default component.exports